import type { GameTheme } from "@skillscratch/shared-types";
import background from "./background.webp";
import name from "./name.webp";
import overlay from "./overlay.webp";
import card from "./card.png";

export const tripleCashBlast = {
  id: "triple-cash-blast",
  name: "Triple Cash Blast",
  
  colorScheme: {
    tileColors: [
      { background: "#FFD700", text: "#fff" },  // very bright yellow (gold)
      { background: "#FFC000", text: "#fff" },  // bright yellow (amber)
      { background: "#DAA520", text: "#fff" },  // medium-dark yellow (goldenrod)
      { background: "#B8860B", text: "#fff" },  // dark yellow (dark goldenrod)
    ],
    overlayPattern: overlay,
    overlayColor: "#8B6914",  // keeping darker overlayColor (darker goldenrod)
    scratchColor: "#A67C00",  // keeping darker scratchColor (dark amber)
    
    controlColor: "#996515",  // keeping darker controlColor (golden brown)
    onControlColor: "#fff",
  },
  
  nameImage: name,
  background: background,
  card: card,
} satisfies GameTheme;